<template>
  <div class="content">
    <el-card style="width:100%;text-align:left;margin-top: 16px;">
      <div class="recent">My Profile</div>
      <div>
        <el-form label-position="top" label-width="100px" :model="profileForm">
          <el-form-item label="User Name">
            <el-input v-model="user.email" disabled></el-input>
          </el-form-item>
          <el-form-item label="Name">
            <el-input v-model="profileForm.name" placeholder="Enter your name"><el-button @click="saveName" slot="append" icon="el-icon-check"></el-button></el-input>
          </el-form-item>
          <el-form-item label="Change Password">
            <el-button type="primary" @click="resetPassword">Send Password Change Email</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
/* eslint-disable handle-callback-err */

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Profile',
  props: ['user'],
  data () {
    return {
      profileForm: {
        name: this.user.displayName
      }
    }
  },
  methods: {
    saveName: function () {
      let user = firebase.auth().currentUser
      let name = this.profileForm.name
      let that = this
      user.updateProfile({
        displayName: name
      }).then(() => {
        that.$message({
          message: 'Your name has been updated',
          center: true,
          type: 'success'
        })
      })
    },
    resetPassword: function () {
      let auth = firebase.auth()
      let user = auth.currentUser
      let that = this
      auth.sendPasswordResetEmail(user.email).then(function () {
        // Email sent.
        that.$message({
          message: `A verify email has been sent to ${user.email}`,
          center: true,
          type: 'success'
        })
      }).catch(function (err) {
        // An error happened.
        that.$message({
          message: `Unable to send verify email to ${user.email}, please try again later`,
          center: true,
          type: 'error'
        })
        // console.log(err)
      })
    }
  }
}
</script>

<style>
.content {
  width: 60%;
  margin: auto;
}
.recent {
  font-family: Montserrat, sans-serif;
  margin-top: 8px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 812px) {
  .content {
    width: 100%;
    margin: auto;
  }
}
</style>
